module.exports = __webpack_public_path__ + "img/good.2b08a84a.png";